// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__14Uc0","alertIcon":"ConfirmModal_alertIcon__1uQc_"};